let selectedInpostPoint = {};
const closeButton = $('#inpost-point-confirmed');
const dismissButton = $('.dismiss-delivery-modal');
const choosePoint = 'Wybierz punkt';

export default class InPostComponent {

  constructor(modalSelector) {
    this.selector = modalSelector;

    $(modalSelector).on('show.bs.modal', function() {
      selectedInpostPoint = {}
      const inpostBox = $('.shipping .inpost-box');
      const inpostPoint = $('.shipping .inpost-point');

      if (inpostBox.hasClass('hidden')) {
        inpostBox.removeClass('hidden');
        inpostPoint.addClass('hidden');
      }

      init();

      $(modalSelector).find('#point-list').find('.selectedPoint').removeClass('selectedPoint');

      window.easyPackAsyncInit = function () {
        easyPack.init({
          defaultLocale: 'pl',
          mapType: 'osm',
          searchType: 'osm',
          points: {
            types: ['parcel_locker_only']
          },
          map: {
            initialTypes: ['parcel_locker_only']
          }
        });

        easyPack.mapWidget('easypack-map', function(point) {
          closeButton.prop('disabled', false);
          selectedInpostPoint = point;
          $(modalSelector).find('.leaflet-pane.leaflet-popup-pane').html('');
          $(modalSelector).find('#point-list').find('li > a[href="#' + point.name + '"]').parent().addClass('selectedPoint');

          $('.shipping .inpost-point .name').html('Paczkomat ' + point.name);
          $('.shipping .inpost-point .address').html(point.address.line1);
          inpostBox.addClass('hidden');
          inpostPoint.removeClass('hidden');
        });
      }
    });

    function init() {
      closeButton.html(choosePoint).prop('disabled', true);
    }

    dismissButton.on('click' , function () {
      selectedInpostPoint = {};
    });

    closeButton.on('click' , function () {
      $(modalSelector).modal('hide');
    });
  }

  getSelectedPoint() {
    return selectedInpostPoint;
  }

}
